
import invoke from '../utils/invoke';

export const holdersCount = () => {
    return invoke({
        url : `https://usiwalletapi.nucoin.com.au/v1/bc/wallet/count`,
        method  :   'GET'
    })
}
